export default __webpack_public_path__ + "static/media/Group 12505.79a9048b.svg";